module.exports = __webpack_public_path__ + "static/media/service-mobile-apps.4d61c955.png";